// src/pages/portal/PortalSettings.js — General account settings for a
// partner: their name/email on file, a password change, and their record
// (deals introduced, names submitted; moved off the dashboard 10/28). Nothing else —
// no integrations, no admin controls; those belong to the internal Settings
// page and partners never see it.
import { useAuth } from '../../context/AuthContext'
import PortalSearch from '../../components/portal/PortalSearch'
import PasswordForm from '../../components/PasswordForm'
import PartnerRecord from '../../components/portal/PartnerRecord'
import { PORTAL_PAGE_TITLE_STYLE } from '../../lib/portalPageTitleStyle'

function AccountSection() {
  const { user, profile } = useAuth()

  return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h2 style={{ fontSize: 15, fontWeight: 600, marginBottom: 16, color: 'var(--text-primary)' }}>Account</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 380 }}>
        <div className="input-group">
          <label className="input-label">Name</label>
          <input className="input" value={profile?.name || '—'} readOnly style={{ opacity: 0.7, cursor: 'default' }} />
        </div>
        <div className="input-group">
          <label className="input-label">Email</label>
          <input className="input" value={user?.email || '—'} readOnly style={{ opacity: 0.7, cursor: 'default' }} />
        </div>
        <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>
          To update your name or email, contact your RGA relationship manager.
        </p>
      </div>
    </div>
  )
}

function PasswordSection() {
  return (
    <div className="card">
      <h2 style={{ fontSize: 15, fontWeight: 600, marginBottom: 4, color: 'var(--text-primary)' }}>Change password</h2>
      <p style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 16 }}>
        Choose a new password for signing in to the partner portal.
      </p>
      <PasswordForm />
    </div>
  )
}

export default function PortalSettings() {
  return (
    <div className="page">
      <div className="page-header">
        <div className="page-header-text" style={{ flex: 1 }}>
          <h1 style={PORTAL_PAGE_TITLE_STYLE}>Settings</h1>
        </div>
        <PortalSearch />
      </div>

      <div style={{ maxWidth: 700 }}>
        <AccountSection />
        <PasswordSection />
        <PartnerRecord />
      </div>
    </div>
  )
}
